import useApiAtendimento from "./atendimento";

export const useFetchUsuarioAtivo = () => useApiAtendimento("/usuario-ativo", "GET");
